// extracted by mini-css-extract-plugin
export default {"price":"ServicesGrid_price__MDhup","theme-grayscale":"ServicesGrid_theme-grayscale__naMSO"};